import { useEffect, useMemo, useState } from 'react';
import styles from './autoComplete.module.css';
import { debounce } from '../../../utils/debounce';
import { fetchDropdowns } from '../../../pages/supDropdown/dropdownFun/dropdownCRUD';

const Autocomplete = ({ dropdownData = [], selectedData = [], onChange, multiSelect, placeholder, error }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const handleSearch = (searchValue) => {
        if (searchValue.length > 0) {
            if (multiSelect) {
                const filtered = dropdownData.filter(
                    (item) =>
                        item.displayName.toLowerCase().includes(searchValue.toLowerCase()) &&
                        !selectedData.some((selected) => selected._id === item._id)
                );
                setSuggestions(filtered);
            } else {
                const filtered = dropdownData.filter((item) =>
                    item.displayName.toLowerCase().includes(searchValue.toLowerCase())
                );
                setSuggestions(filtered);
            }
        } else {
            setSuggestions([]);
        }
    };

    const debouncedSearch = useMemo(() => debounce(handleSearch, 300), [dropdownData, selectedData]);

    const handleSelect = (item) => {
        if (multiSelect) {
            const updated = [...selectedData, item];
            onChange(updated);
            setSearchQuery('');
        } else {
            onChange(item.name);
            setSearchQuery(item.displayName);
        }
        setSuggestions([]);
    };

    const handleRemoveItem = (itemToRemove) => {
        const updated = selectedData.filter((item) => item._id !== itemToRemove._id);
        onChange(updated);
    };

    return (
        <div className={styles.autoComplete}>
            <div className={styles.autoCompleteInputDiv}>
                <input
                    type='text'
                    name={'autoComplete'}
                    id={'autoComplete'}
                    value={searchQuery || selectedData}
                    onChange={(event) => {
                        const value = event.target.value;
                        setSearchQuery(value);
                        debouncedSearch(value);
                        if (!multiSelect && value.trim() === '') {
                            onChange('');
                        }
                    }}
                    placeholder={placeholder}
                    className={`${styles.autoCompleteInput} ${error ? 'error-highlight' : ''}`}
                />
            </div>
            {suggestions.length > 0 && (
                <ul className={styles.autoCompleteSugessionsContainer}>
                    {suggestions.map((suggestionsItem) => {
                        return (
                            <li
                                key={suggestionsItem._id}
                                onClick={() => handleSelect(suggestionsItem)}
                                className={styles.suggestionsItem}
                            >
                                {suggestionsItem.displayName}
                            </li>
                        );
                    })}
                </ul>
            )}
            <div className={styles.displaySelectedData}>
                {multiSelect &&
                    selectedData.map((item) => (
                        <div key={item._id} className={styles.displaySelectedDataItem}>
                            <span>{item.displayName}</span>
                            <span onClick={() => handleRemoveItem(item)}>X</span>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Autocomplete;
